/*
 * bulkExportDownload.ts
 * Triggers the download of a finished bulk export. The result file is a
 * direct S3/media url, so no blob request is needed, unlike a same-origin
 * API endpoint response.
 */

// Opens the export result file in a new tab to trigger the browser download
export function bulkExportDownload(resultFileUrl: string) {
    window.open(resultFileUrl, '_blank', 'noopener,noreferrer');
}
